import styled from 'styled-components';
import React, { FC, useEffect, useState } from 'react';
import Variables from '../../../design-system/variables';
import OvRadioGroup from '../molecules/OvRadioGroup';
import { QuestionOption } from '../../../common/model/dto/survey/question-option';

export interface OvRadioGroupSurveyQuestionProps {
  onChange?: (value: string) => void;
  value?: string;
  question_options?: QuestionOption[];
}

const OvRadioGroupSurveyQuestion: FC<OvRadioGroupSurveyQuestionProps> = ({
  onChange,
  value,
  question_options,
}) => {
  const [selectedValue, setSelectedValue] = useState<string | null>(null);

  useEffect(() => {
    if (value !== selectedValue && value) {
      setSelectedValue(value);
    }
  }, [value, selectedValue]);

  const handleValueChange = (event: any) => {
    const { value } = event.target;
    setSelectedValue(value);
    onChange && onChange(value);
  };

  return (
    <Container>
      <StyledOvRadioGroup
        value={value}
        onChange={handleValueChange}
        options={question_options?.map(({ label }) => ({
          value: label,
          label,
        }))}
      />
    </Container>
  );
};

export default OvRadioGroupSurveyQuestion;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
`;

const StyledOvRadioGroup = styled(OvRadioGroup)`
  && {
    .MuiFormControlLabel-root {
      margin-right: 1rem;
      font-size: ${Variables.fontSizes.MEDIUM};
    }

    .MuiRadio-root {
      padding: 0.5rem;
      border-radius: 50%;
    }
  }
`;
